import styled, { css } from 'styled-components';

import OverlayTexture from 'assets/overlay-texture.png';

import {
    ColorsTransparencies,
    mobileCssQuerist,
    spacing,
    transparencies,
} from 'styles/theme';

export interface SelectionWrapperProps {
    $isSelected: boolean;
    $backgroundColor?: ColorsTransparencies;
    $padding?: string;
}

export const SelectionWrapper = styled.div<SelectionWrapperProps>`
    position: relative;
    border-radius: ${spacing.radiusLarge};
    border: 1px solid ${transparencies.darkJungle20};
    width: 100%;
    padding: ${spacing.large};
    overflow: hidden;

    ${mobileCssQuerist(css`
        padding: ${spacing.medium};
    `)}

    ${(props) =>
        props.$isSelected === true
            ? css`
                  border-color: ${transparencies.darkJungle80};
              `
            : null};

    ${(props) =>
        props.$backgroundColor == null
            ? null
            : css`
                  background-color: ${props.$backgroundColor}1A;
              `};

    ${({ $padding }) =>
        $padding &&
        css`
            padding: ${$padding};

            ${mobileCssQuerist(css`
                padding: ${$padding};
            `)}
        `};
`;

export const BackgroundOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${OverlayTexture});
    opacity: 0.03;
`;

export const ContentWrapper = styled.div`
    position: relative;
`;

export const TitleWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: start;
`;

interface ExpanderProps {
    $isExpanded: boolean;
}

export const ContentExpander = styled.div<ExpanderProps>`
    overflow: hidden;
    /* New way of writing styled-component props — so much more concise! */
    max-height: ${({ $isExpanded }) => ($isExpanded ? css`1000px` : css`0`)};
    transition: max-height 0.5s ease-in-out;
`;

export const ChevronWrapper = styled.button.attrs({
    type: 'button',
})<ExpanderProps>`
    transition: 0.2s;
    transform: rotate(90deg)
        ${({ $isExpanded }) => ($isExpanded ? css`scaleX(-1)` : css`scaleX(1)`)};
`;
